module.exports = __webpack_public_path__ + "img/mini-006.07427302.jpg";